import { supabase } from '../utils/supabaseClient';
import { Match, MatchTeam, Stadium, Tournament } from '../types/matchTypes';

export interface FetchMatchesResult {
    matches: Match[];
    error: Error | null;
    hasMore: boolean;
}

export interface FetchMatchesOptions {
    startDate?: Date;
    endDate?: Date;
    teamId?: number;
    tournamentId?: number;
    parentTournamentId?: number;
    matchIds?: number[];
    limit?: number;
    offset?: number;
    order?: 'asc' | 'desc';
    count?: number;
}

export async function fetchMatches(options: FetchMatchesOptions): Promise<FetchMatchesResult> {
    console.log('fetchMatches function called with options:', options);
    try {
        let query = supabase
            .from('matches_view')
            .select('*');

        if (options.matchIds && options.matchIds.length > 0) {
            query = query.in('id', options.matchIds);
        } else {
            if (options.startDate) {
                query = query.gte('actual_start_time', options.startDate.toISOString());
            }
            if (options.endDate) {
                query = query.lt('actual_start_time', options.endDate.toISOString());
            }
            if (options.teamId) {
                query = query.or(`fk_team_host.eq.${options.teamId},fk_team_guest.eq.${options.teamId}`);
            }
            if (options.tournamentId) {
                query = query.eq('tournament_id', options.tournamentId);
            }
            if (options.parentTournamentId) {
                query = query.eq('competition_id', options.parentTournamentId);
            }
        }

        query = query.order('actual_start_time', { ascending: options.order === 'asc' });

        if (options.limit) {
            query = query.limit(options.limit + 1);
        }
        if (options.offset) {
            query = query.range(options.offset, options.offset + (options.limit || 0) - 1);
        }

        const { data, error } = await query;

        if (error) throw error;

        if (!data || data.length === 0) {
            console.log('No matches found');
            return { matches: [], error: null, hasMore: false };
        }

        let hasMore = false;
        if (options.limit && data.length > options.limit) {
            hasMore = true;
            data.pop();
        }

        // Данные уже в нужном формате, просто приводим их к типу Match
        const matches: Match[] = data as Match[];
        console.log('Matches fetched:', matches)
        return { matches, error: null, hasMore };
    } catch (error) {
        console.error('Error fetching data:', error);
        return { matches: [], error: error as Error, hasMore: false };
    }
}